module.exports = __webpack_public_path__ + "40ccd05e024e316a25aec47ec0acfc8d.svg";